import { isLoadingAction } from '@libs/utils';
import { ActionActionTypeEnum, ActionTypeEnum, TWAction } from '@libs/types';

export const isShowLoader = (action: TWAction, isShowLoader = false) => {
    if (isShowLoader) {
        return true;
    }
    return isLoadingAction(action);
};

export const actionsCall = <TResult>(type: ActionActionTypeEnum | string, func: (a: TWAction) => TResult, actionsArr?: Array<TWAction>): TResult[] => {
    if (!Array.isArray(actionsArr) || actionsArr.length === 0) {
        return [];
    }
    const filteredActions = actionsArr.filter((a) => a?.actionType === type);
    return includeAllPlayerActionsNadOneNonPlayer(filteredActions)
        .filter((a) => a !== null)
        .map((a) => func(a));
};

export const actionsCallByTypeAndName = <TResult>(
    type: ActionActionTypeEnum | string,
    name: string,
    func: (a: TWAction) => TResult,
    actionsArr?: Array<TWAction>,
): TResult[] => {
    if (!Array.isArray(actionsArr) || actionsArr.length === 0) {
        return [];
    }
    const filteredActions = actionsArr.filter((a) => a?.actionType === type && a?.name === name);
    return includeAllPlayerActionsNadOneNonPlayer(filteredActions)
        .filter((a) => a !== null)
        .map((a) => func(a));
};

const includeAllPlayerActionsNadOneNonPlayer = (filteredActions: Array<TWAction>) => {
    const finalActions = filteredActions.filter((a) => a.type === ActionTypeEnum.Player);
    const nonPlayerAction = filteredActions.find((a) => a.type !== ActionTypeEnum.Player);
    if (nonPlayerAction) {
        finalActions.push(nonPlayerAction);
    }
    return finalActions;
};
